import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { Sun, Moon, BoxArrowRight } from 'react-bootstrap-icons';
import { AuthContext } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { TIER_LABELS } from '../../constants/subscriptionTiers';

const pageTitles = {
  '/app/dashboard': 'Dashboard',
  '/app/settings': 'Settings',
  '/app/devices/register': 'Register Device',
};

const getPageTitle = (pathname) => {
  if (pageTitles[pathname]) return pageTitles[pathname];
  if (pathname.startsWith('/app/device/')) return 'Device Monitor';
  if (pathname.startsWith('/app/devices/edit/')) return 'Device Setup';
  return 'Garden Sync';
};

const AppTopBar = () => {
  const { user, token, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const [subTier, setSubTier] = useState('');

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${process.env.REACT_APP_API_URL || ''}/api/user/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSubTier(res.data.subTier || 'free'))
      .catch(() => setSubTier('free'));
  }, [token]);

  const initials = [user?.firstName?.[0], user?.lastName?.[0]]
    .filter(Boolean)
    .join('')
    .toUpperCase() || '?';

  return (
    <header className="app-topbar">
      <h1 className="app-topbar__title">{getPageTitle(location.pathname)}</h1>
      <div className="app-topbar__actions">
        {subTier && (
          <span className="app-tier-badge">{TIER_LABELS[subTier] || subTier}</span>
        )}
        <span className="app-user-avatar" title={user?.email}>{initials}</span>
        <Button
          variant="link"
          className="app-theme-toggle"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </Button>
        <Button
          variant="outline-danger"
          size="sm"
          onClick={logout}
          className="d-flex align-items-center gap-1"
        >
          <BoxArrowRight size={16} />
          Logout
        </Button>
      </div>
    </header>
  );
};

export default AppTopBar;